import { Link, useLocation } from "react-router-dom";

export default function Header() {
  const location = useLocation();

  function isActive(path: string) {
    return location.pathname === path;
  }

  function navLinkStyle(path: string): React.CSSProperties {
    const active = isActive(path);
    return {
      textDecoration: "none",
      color: "inherit",
      opacity: active ? 1 : 0.78,
      fontWeight: active ? 700 : 500,
      padding: "6px 0",
      borderBottom: active ? "2px solid rgba(109,94,252,0.9)" : "2px solid transparent",
      transition: "all 0.15s ease",
    };
  }

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        padding: "14px 16px",
        display: "flex",
        alignItems: "center",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        background: "rgba(5, 8, 20, 0.75)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        flexWrap: "wrap",
      }}
    >
      <Link
        to="/"
        style={{
          fontWeight: 800,
          textDecoration: "none",
          color: "inherit",
          letterSpacing: 0.3,
          fontSize: 16,
        }}
      >
        Lumia<span style={{ opacity: 0.6 }}> RAMS</span>
      </Link>

      <nav
        style={{
          marginLeft: "auto",
          display: "flex",
          gap: 18,
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Link to="/" style={navLinkStyle("/")}>
          Home
        </Link>

        <Link to="/tools" style={navLinkStyle("/tools")}>
          Tools
        </Link>

        <Link to="/support" style={navLinkStyle("/support")}>
          Support
        </Link>

        <Link
          to="/rams"
          style={{
            textDecoration: "none",
            padding: "9px 14px",
            borderRadius: 10,
            background: isActive("/rams") ? "#7a6cff" : "#6d5efc",
            color: "#fff",
            fontWeight: 700,
            boxShadow: "0 8px 24px rgba(109,94,252,0.28)",
            transition: "all 0.15s ease",
          }}
        >
          Create RAMS
        </Link>
      </nav>
    </header>
  );
}